<template>
  <b-container class="d-flex flex-column h-100" fluid>
    <div
      class="pagetitle-container d-flex justify-content-start align-items-center"
    >
      <div class="page-title">
        <h2>
          Intervalové dáta
          <small>({{ count | formatNumber }})</small>
        </h2>
      </div>
      <div class="d-flex flex-grow-1">
        <input-filter
          ref="filter"
          :filters="table.filter"
          :options="filterOptions"
          @onReset="resetFilter"
          @onSearch="search"
        >
          <template #filter>
            <b-row>
              <b-col md="4">
                <b-form-group
                  label="Komodita:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="energetic"
                >
                  <b-input-group>
                    <selectbox
                      v-model="table.filter.type"
                      :allow-empty="false"
                      :options="[
                        { id: 1, name: 'Elektrina' },
                        { id: 2, name: 'Plyn' },
                      ]"
                      :searchable="false"
                      @input="changeType"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  :label="activeType === 1 ? 'Prekročenie:' : 'Nadlimit:'"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="overflows"
                >
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="table.filter.overflows"
                      :options="
                        activeType == 1
                          ? [
                              { id: 1, name: 'Prekročenie RK' },
                              { id: 2, name: 'Prekročenie MRK' },
                              { id: 3, name: 'Všetky prekročenia' },
                            ]
                          : [
                              { id: 1, name: 'Nadlimit 105%' },
                              { id: 2, name: 'Nadlimit 110%' },
                              { id: 3, name: 'Všetky nadlimity' },
                            ]
                      "
                      :searchable="false"
                      @input="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          table.filter.overflows = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  :label-class="activeType === 1 ? 'p-0' : ''"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="state"
                >
                  <template #label>
                    <template v-if="activeType === 1">
                      <selectbox
                        v-model="table.filter.state.col"
                        :allow-empty="false"
                        :options="[
                          { id: 'consumption', name: 'Činný odber' },
                          { id: 'idleConsumption', name: 'Jalový odber' },
                          { id: 'idleSupply', name: 'Jalová dodávka' },
                        ]"
                        :searchable="false"
                        @input="search"
                      />
                    </template>
                    <template v-else> Odber:</template>
                  </template>
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="table.filter.state.value"
                      :options="[
                        { id: 1, name: 'Žiadny' },
                        { id: 2, name: 'Nulový' },
                        { id: 3, name: 'Nameraný' },
                      ]"
                      :searchable="false"
                      @input="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          table.filter.state.value = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group
                  label="Dátum:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="date"
                >
                  <b-input-group class="input-group-labeled">
                    <date-picker
                      v-model="table.filter.date"
                      class="flex-grow-1 daterange-sm"
                      opens="right"
                      @update="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          table.filter.date = { ge: null, lt: null }
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Stiahnuté dňa:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="created_at"
                >
                  <b-input-group class="input-group-labeled">
                    <date-picker
                      v-model="table.filter.created_at"
                      class="flex-grow-1 daterange-sm"
                      opens="right"
                      @update="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          table.filter.created_at = { ge: null, lt: null }
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Distrib. územie:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="distributionArea"
                >
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="table.filter.distributionArea"
                      :options="
                        activeType == 1
                          ? [
                              { id: 2, name: 'VSD' },
                              { id: 3, name: 'SSD' },
                              { id: 4, name: 'ZSDIS' },
                            ]
                          : [{ id: 1, name: 'SPP-distribúcia, a.s.' }]
                      "
                      :searchable="false"
                      @input="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          table.filter.distributionArea = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group
                  label="Stav:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="consumptionState"
                >
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="table.filter.consumptionState"
                      :options="[
                        { id: 0, name: 'Žiadne dáta' },
                        { id: 1, name: 'Čiastočné dáta' },
                        { id: 2, name: 'Všetky dáta' },
                      ]"
                      :searchable="false"
                      @input="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          table.filter.consumptionState = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
        </input-filter>
      </div>
      <div class="ml-3">
        <b-dropdown
          class="mr-1"
          menu-class="dropdown-menu-animated"
          right
          size="lg"
          variant="secondary"
        >
          <template #button-content>
            <b-icon icon="gear" />
          </template>
          <b-dropdown-item-button @click="exportLog">
            <b-icon class="mr-1" icon="file-earmark-spreadsheet" />
            Exportovať
          </b-dropdown-item-button>
        </b-dropdown>
      </div>
    </div>
    <div ref="scroll" v-bar class="bar-out">
      <div>
        <IntervalStats
          :default-filter="$options.data().table.filter"
          :filter.sync="table.filter"
          @filter="search"
        />
        <server-table
          ref="table"
          :api-request="apiRequest"
          :columns="activeType === 1 ? table.columns : table.gasColumns"
          :searchable="false"
          :sort-by.sync="table.sortBy"
          :sort-desc="true"
          bordered
          hover
          striped
          @refreshed="onLoaded"
        >
          <template #cell(actions)="data">
            <b-dropdown class="btn-p-0" no-caret variant="link">
              <template slot="button-content">
                <b-icon icon="text-indent-left" scale="1.25x" />
              </template>
              <b-dropdown-item
                :to="{
                  name: 'intervalData',
                  params: { energetics_id: data.item.energetics_id },
                }"
              >
                <b-icon class="mr-1" icon="person" />
                Intervalové dáta
              </b-dropdown-item>
            </b-dropdown>
          </template>
          <template #cell(energetics)="data">
            <template v-if="data.item.energetics._type.const === 'POWER'">
              <div class="text-nowrap">
                <b-badge class="bg-power align-middle">
                  <icon class="icon-fw" name="plug" scale="0.75" />
                </b-badge>
                {{ data.item.energetics.powerNumber }}
              </div>
            </template>
            <template v-if="data.item.energetics._type.const === 'GAS'">
              <div class="text-nowrap">
                <b-badge class="bg-gas align-middle">
                  <icon class="icon-fw" name="fire" scale="0.75" />
                </b-badge>
                {{ data.item.energetics.gasNumber }}
              </div>
            </template>
            <div class="fs-sm text-muted">
              {{ data.item.energetics.localityName }}
            </div>
          </template>
          <template #cell(overflows)="data">
            <template v-if="data.item.energetics._type.const === 'POWER'">
              <div v-if="data.value.mrk > 0">
                <b-badge class="align-top fs-sm" variant="danger">
                  {{ data.value.mrk }}x - prekročenie MRK
                </b-badge>
              </div>
              <div v-if="data.value.rk > 0">
                <b-badge class="align-top fs-sm" variant="danger">
                  {{ data.value.rk }}x - prekročenie RK
                </b-badge>
              </div>
              <div v-if="!data.value.rk > 0 && !data.value.mrk > 0">
                <b-badge class="align-top fs-sm" variant="success">
                  Žiadne prekročenie
                </b-badge>
              </div>
            </template>
            <template v-if="data.item.energetics._type.const === 'GAS'">
              <b-badge
                v-if="data.item.overLimitOver110percent"
                class="align-top fs-sm"
                variant="danger"
              >
                Nadlimit 110%:
                {{ data.item.overLimitOver110percent | formatNumber(2) }} m3
              </b-badge>
              <b-badge
                v-else-if="data.item.overLimit105to110percent"
                class="align-top fs-sm"
                variant="danger"
              >
                Nadlimit 105%:
                {{ data.item.overLimit105to110percent | formatNumber(2) }} m3
              </b-badge>
              <b-badge v-else class="align-top fs-sm" variant="success">
                Bez nadlimitu
              </b-badge>
            </template>
          </template>
          <template #cell(created_at)="data">
            <div v-if="data.item.created_at">
              {{ data.item.created_at | formatDateTime('DD.MM.YYYY - HH:mm') }}
            </div>
            <div
              v-if="
                $options.filters.formatDateTime(
                  data.item.created_at,
                  'DD.MM.YYYY - HH:mm',
                ) !==
                $options.filters.formatDateTime(
                  data.item.updated_at,
                  'DD.MM.YYYY - HH:mm',
                )
              "
              class="fs-sm text-muted"
            >
              <b-icon icon="clock-history" />
              {{ data.item.updated_at | formatDateTime('DD.MM.YYYY - HH:mm') }}
            </div>
          </template>
          <template #cell(state)="data">
            <template
              v-if="data.item.consumptionState === 0 || data.item.state === 0"
            >
              <b-badge class="align-top fs-sm" variant="danger">
                Žiadne dáta
              </b-badge>
            </template>
            <template
              v-if="data.item.consumptionState === 1 || data.item.state === 1"
            >
              <b-badge class="align-top fs-sm" variant="warning">
                Čiastočné dáta
              </b-badge>
            </template>
            <template
              v-if="data.item.consumptionState === 2 || data.item.state === 2"
            >
              <b-badge class="align-top fs-sm" variant="success">
                Všetky dáta
              </b-badge>
            </template>
          </template>
        </server-table>
      </div>
    </div>
  </b-container>
</template>
<script>
import 'bootstrap'
import InputFilter from '@/components/InputFilter'
import Selectbox from '@/components/inputs/Selectbox'
import DatePicker from '@/components/inputs/DatePicker'
import ServerTable from '@/components/ServerTable'
import IntervalStats from './IntervalStats'
import moment from 'moment'

export default {
  components: {
    IntervalStats,
    InputFilter,
    Selectbox,
    DatePicker,
    ServerTable,
  },
  data() {
    return {
      loading: false,
      table: {
        columns: [
          {
            key: 'actions',
            label: '',
            class: 'th-shrink',
          },
          {
            key: 'customer',
            label: 'Názov spoločnosti',
            formatter: (value, key, item) =>
              item.energetics.customer.name || '-',
            sortable: true,
            sortableKey: 'customers.name',
            searchable: true,
          },
          {
            key: 'customerGroup',
            label: 'Skupina',
            formatter: (value, key, item) =>
              item.energetics.customer.group
                ? item.energetics.customer.group.name
                : '-',
            sortable: true,
            sortableKey: 'customer_groups.name',
            searchable: true,
          },
          {
            key: 'energetics',
            label: 'Odberné miesto',
            sortable: true,
            sortableKey: 'energetics.powerNumber, energetics.gasNumber',
            searchable: true,
          },
          {
            key: 'date',
            label: 'Dátum',
            formatter: (value) =>
              value ? this.$moment(value).format('DD.MM.YYYY') : '-',
            sortable: true,
          },
          {
            key: 'overflows',
            label: 'Prekročenie',
            tdClass: 'text-nowrap',
          },
          {
            key: 'created_at',
            label: 'Stiahnuté dňa',
            sortable: true,
          },
          {
            key: 'consumption',
            label: 'Činný odber (kW)',
            class: 'text-right',
            formatter: (value) =>
              value !== null
                ? this.$options.filters.formatNumber(value, 2)
                : '-',
            sortable: true,
          },
          {
            key: 'idleConsumption',
            label: 'Jalový odber (kVArh)',
            class: 'text-right',
            formatter: (value) =>
              value !== null
                ? this.$options.filters.formatNumber(value, 2)
                : '-',
            sortable: true,
          },
          {
            key: 'idleSupply',
            label: 'Jalová dodávka (kVArh)',
            class: 'text-right',
            formatter: (value) =>
              value !== null
                ? this.$options.filters.formatNumber(value, 2)
                : '-',
            sortable: true,
          },
          {
            key: 'state',
            label: 'Stav',
            tdClass: 'text-nowrap',
          },
        ],
        gasColumns: [
          {
            key: 'actions',
            label: '',
            class: 'th-shrink',
          },
          {
            key: 'customer',
            label: 'Názov spoločnosti',
            formatter: (value, key, item) =>
              item.energetics.customer.name || '-',
            sortable: true,
            sortableKey: 'customers.name',
            searchable: true,
          },
          {
            key: 'customerGroup',
            label: 'Skupina',
            formatter: (value, key, item) =>
              item.energetics.customer.group
                ? item.energetics.customer.group.name
                : '-',
            sortable: true,
            sortableKey: 'customer_groups.name',
            searchable: true,
          },
          {
            key: 'energetics',
            label: 'Odberné miesto',
            tdClass: 'text-nowrap',
            sortable: true,
            sortableKey: 'energetics.powerNumber, energetics.gasNumber',
            searchable: true,
          },
          {
            key: 'date',
            label: 'Dátum',
            formatter: (value) =>
              value ? this.$moment(value).format('DD.MM.YYYY') : '-',
            sortable: true,
          },
          {
            key: 'overflows',
            label: 'Nadlimit (m3)',
            tdClass: 'text-nowrap',
          },
          {
            key: 'created_at',
            label: 'Stiahnuté dňa',
            formatter: (value) =>
              value ? this.$options.filters.formatDateTime(value) : '-',
            sortable: true,
          },
          {
            key: 'consumption',
            label: 'Odber (m3)',
            class: 'text-right',
            formatter: (value) =>
              value !== null
                ? this.$options.filters.formatNumber(value, 2)
                : '-',
            sortable: true,
          },
          {
            key: 'state',
            label: 'Stav',
            tdClass: 'text-nowrap',
          },
        ],
        sortBy: 'date',
        filter: {
          type: 1,
          overflows: null,
          state: {
            col: 'consumption',
            value: null,
          },
          date: {
            ge: moment().startOf('year').format('YYYY-MM-DD'),
            lt: moment().format('YYYY-MM-DD'),
          },
          created_at: { ge: null, lt: null },
          distributionArea: null,
          consumptionState: null,
        },
      },
      filterOptions: {
        placeholder: 'Filtrovanie a hľadanie...',
      },
      count: null,
    }
  },
  computed: {
    activeType() {
      return this.table.filter.type
    },
  },
  methods: {
    apiRequest(params) {
      return this.$api.get('energy_data/get_logs', {
        params: { filter: this.table.filter, ...params },
      })
    },
    onLoaded() {
      this.count = this.$refs.table.totalRows
    },
    search() {
      this.$refs.table.searchVal = this.$refs.filter.value
      this.$nextTick(() => {
        this.$refs.table.search()
      })
    },
    resetFilter() {
      this.$refs.table.reset()
    },
    changeType(val) {
      this.table.filter = this.$options.data().table.filter
      this.$nextTick(() => {
        this.table.filter.type = val
        this.search()
      })
    },
    exportLog() {
      this.$swal({
        toast: true,
        type: 'info',
        position: 'top-end',
        title: 'Pripravujem export...',
      })
      this.$api
        .get('energy_data/export_log', {
          params: {
            query: this.$refs.filter.value,
            filter: this.table.filter,
            ...this.$refs.table.getRequestParams(),
            startAt: 0,
            maxResults: -1,
          },
          responseType: 'blob',
        })
        .then((res) => {
          saveAs(new Blob([res.data]), 'api-log.xlsx')
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: 'Export pripravený',
            timer: 5000,
          })
        })
        .catch(() => {
          this.$swal({
            toast: true,
            type: 'error',
            position: 'top-end',
            title: 'Chyba pri exportovaní',
            timer: 5000,
          })
        })
    },
  },
}
</script>
